var _ellipse, _path, _path2, _ellipse2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5,
    cy: 26.8479,
    rx: 25.5,
    ry: 26.0715,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6026 19.8329L16.7401 16.7354C8.14113 25.3609 13.1572 33.7125 16.7401 36.81L19.6026 33.7125C14.6021 28.2798 17.519 22.1958 19.6026 19.8329Z",
    fill: "#FBE20B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3162 22.6323L19.5836 19.8027C14.5884 25.9979 17.276 31.508 19.5835 33.7121L22.1247 31.0315C19.9048 27.8743 20.9088 24.1888 22.3162 22.6323Z",
    fill: "#FEB300"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.368,
    cy: 26.9207,
    rx: 6.19222,
    ry: 6.3143,
    fill: "#1916BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0695 22.3643C23.4509 23.864 25.1378 27.6546 21.8225 31.3294C18.9135 27.9629 20.2878 23.8833 22.0695 22.3643Z",
    fill: "#FF7D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3999 28.8438C26.0919 28.8438 25.8159 28.7938 25.5719 28.6938C25.3279 28.5938 25.1319 28.4458 24.9839 28.2498C24.8399 28.0538 24.7639 27.8178 24.7559 27.5418H25.8479C25.8639 27.6978 25.9179 27.8178 26.0099 27.9018C26.1019 27.9818 26.2219 28.0218 26.3699 28.0218C26.5219 28.0218 26.6419 27.9878 26.7299 27.9198C26.8179 27.8478 26.8619 27.7498 26.8619 27.6258C26.8619 27.5218 26.8259 27.4358 26.7539 27.3678C26.6859 27.2998 26.5999 27.2438 26.4959 27.1998C26.3959 27.1558 26.2519 27.1058 26.0639 27.0498C25.7919 26.9658 25.5699 26.8818 25.3979 26.7978C25.2259 26.7138 25.0779 26.5898 24.9539 26.4258C24.8299 26.2618 24.7679 26.0478 24.7679 25.7838C24.7679 25.3918 24.9099 25.0858 25.1939 24.8658C25.4779 24.6418 25.8479 24.5298 26.3039 24.5298C26.7679 24.5298 27.1419 24.6418 27.4259 24.8658C27.7099 25.0858 27.8619 25.3938 27.8819 25.7898H26.7719C26.7639 25.6538 26.7139 25.5478 26.6219 25.4718C26.5299 25.3918 26.4119 25.3518 26.2679 25.3518C26.1439 25.3518 26.0439 25.3858 25.9679 25.4538C25.8919 25.5178 25.8539 25.6118 25.8539 25.7358C25.8539 25.8718 25.9179 25.9778 26.0459 26.0538C26.1739 26.1298 26.3739 26.2118 26.6459 26.2998C26.9179 26.3918 27.1379 26.4798 27.3059 26.5638C27.4779 26.6478 27.6259 26.7698 27.7499 26.9298C27.8739 27.0898 27.9359 27.2958 27.9359 27.5478C27.9359 27.7878 27.8739 28.0058 27.7499 28.2018C27.6299 28.3978 27.4539 28.5538 27.2219 28.6698C26.9899 28.7858 26.7159 28.8438 26.3999 28.8438Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23809 18.3834C2.00445 16.9835 3.03222 11.938 10.4162 5.93349C17.8001 -0.0710424 27.9023 0.651726 32.0305 1.76368C34.4061 2.20052 39.9986 4.17026 43.3634 8.55453C46.7283 12.9388 44.7654 15.4645 43.3634 16.1793L37.8138 19.7535C37.4828 19.9719 36.6104 20.2777 35.7692 19.7535C34.6203 17.5891 30.7453 13.4511 24.4362 14.2136C16.5499 15.1667 13.2201 21.5405 13.0449 26.3656L13.0261 26.3656C13.2015 31.3419 16.5344 37.9156 24.4283 38.8986C30.7434 39.685 34.6221 35.4172 35.772 33.185C36.614 32.6444 37.4872 32.9598 37.8186 33.185L43.3735 36.8712C44.7769 37.6084 46.7415 40.2133 43.3735 44.735C40.0055 49.2567 34.4077 51.2882 32.0298 51.7388C27.8977 52.8856 17.7858 53.631 10.3948 47.4382C3.00385 41.2455 1.9751 36.0418 2.20896 34.5981C2.20896 34.1066 2.43121 31.6614 5.19113 29.0074C6.1267 27.8278 6.1267 26.7547 6.00976 26.3656L6.03526 26.3656C6.1521 25.9883 6.1521 24.9479 5.21742 23.8041C2.46013 21.2308 2.23809 18.8599 2.23809 18.3834Z",
    fill: "url(#paint0_linear_1090_70)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1090_70",
    x1: 43.9586,
    y1: 38.2228,
    x2: 5.0946,
    y2: 34.4348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22DBDE",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A649FC",
    stopOpacity: 0.89
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.2210a05d.svg";
export { ForwardRef as ReactComponent };